import React, { Component } from 'react';
import Link from 'gatsby-link';
import wsLogo from './ws-logo.svg';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import './winter-nav.css';

  
class WinterNav extends Component {

 constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  render() {
    return (
      <div>
        <Navbar color="dark" dark expand="md">
          <NavbarBrand href="https://wintersense.com">
            <img src={wsLogo} alt="Wintersense Logo"
              style={{
                height: '30px',
                width: '30px'
              }}            
            />
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav navbar>
              <NavItem>
                <NavLink href="https://wintersense.com/sensor">The Sensor</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="https://wintersense.com/sensor">The Platform</NavLink>
              </NavItem>                         
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret color="white" className="text-white">
                  Docs
                </DropdownToggle>
                <DropdownMenu className="mb-2">
                  {/* It's annoyingly difficult here to have dropdown items, that are <Link>'s so I can add an activeStyle or activeClassName but are also reactstrap elements so that the dropdown will actually close when clicked, so in the end I haven't bothered with the active part. */}
                  <DropdownItem>
                    <Link to="/" style={{color: '#212529'}}>Home</Link>
                  </DropdownItem>                  
                  <DropdownItem divider/>
                  <DropdownItem>
                    <a href="https://docs.wintersense.com/api/v1" style={{color: '#212529'}}>API</a>
                  </DropdownItem>
                  <DropdownItem>
                    <Link to="/installation/" style={{color: '#212529'}}>Installation</Link>
                  </DropdownItem>
                  <DropdownItem>
                    <Link to="/field-of-view/" style={{color: '#212529'}}>Field of View</Link>
                  </DropdownItem>                                    
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
            <Nav className="ml-auto">
              <NavItem>
                <a className="btn btn--login" href="https://user.wintersense.com">
                  <i className="fa fa-sign-in mr-1"></i> 
                  Log In
                </a>
              </NavItem>              
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }

}

export default WinterNav



// WEBPACK FOOTER //
// ./src/components/WinterNav/index.js